import { render } from "./lessons.vue?vue&type=template&id=b2474a06"
import script from "./lessons.vue?vue&type=script&lang=js"
export * from "./lessons.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\PC\\Codebase\\390labs\\Coverage\\legacycomposer.com\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__